import { render, staticRenderFns } from "./PropertiesNewHouseAndLandPackage.vue?vue&type=template&id=0394cf62&scoped=true"
import script from "./PropertiesNewHouseAndLandPackage.vue?vue&type=script&lang=ts"
export * from "./PropertiesNewHouseAndLandPackage.vue?vue&type=script&lang=ts"
import style0 from "./PropertiesNewHouseAndLandPackage.vue?vue&type=style&index=0&id=0394cf62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0394cf62",
  null
  
)

export default component.exports